import React from 'react';
import { View, ScrollView, Image, StyleSheet } from 'react-native';
import CustomText from '../../components/customText/CustomText';
import theme from '../../constants/theme.style.js';
import SettingsForm from '../../components/SettingsForm';

const iconActive = require('../../assets/icons/navigation/profile-active.png');
const icon = require('../../assets/icons/navigation/profile.png');

const styles = StyleSheet.create({
  icon: {
    width: theme.ICON_WIDTH,
    height: theme.ICON_WIDTH,
  },
  centerWrap: {
    maxWidth: 900,
    width: '100%',
    alignSelf: 'center',
  },
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: theme.GREEN_DARKER_COLOR,
  },
  body: {
    flex: 1,
    backgroundColor: theme.WHITE_COLOR,
    borderTopLeftRadius: theme.BUTTON_BIG_BORDER_RADIUS,
    borderTopRightRadius: theme.BUTTON_BIG_BORDER_RADIUS,
    padding: theme.CONTAINER_MARGIN,
    paddingTop: 40,
  },
  bodyHeader: {
    fontSize: theme.FONT_SIZE_TITLE,
    fontWeight: theme.FONT_WEIGHT_HEAVY,
    color: theme.GREY_DARKER_COLOR,
  },
  header: {
    marginTop: theme.CONTAINER_MARGIN * 1,
  },
  headerText: {
    color: theme.WHITE_COLOR,
    fontSize: theme.FONT_SIZE_HEADLINE * 3,
    fontFamily: 'Pacifico',
    marginTop: 10,
    padding: 20,
  },
});

export default class ProfileSettings extends React.Component {
  static navigationOptions = {
    title: 'ProfileSettings',
    tabBarIcon: ({ focused }) => {
      const iconimg = focused ? iconActive : icon;
      return <Image source={iconimg} style={styles.icon} />;
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      navigation: props.navigation,
    };
  }

  render() {
    const { navigation } = this.state;
    return (
      <View style={styles.container}>
        <View style={styles.header}>
          <View style={styles.centerWrap}>
            <CustomText style={styles.headerText}>Profile Settings</CustomText>
          </View>
        </View>
        <ScrollView style={styles.body}>
          <View style={styles.centerWrap}>
            <SettingsForm nav={navigation} />
          </View>
        </ScrollView>
      </View>
    );
  }
}
